export const STORAGE_KEYS = {
  EXT_TOKEN_KEY: 'twpub-extToken',
  AUTH_METHOD_KEY: 'twpub-authMethod',
  KEYCLOAK_ADMIN_MODE_KEY: 'twpub-keycloakAdminMode',
  ACCESS_TOKEN_KEY: 'twpub-accessToken',
  COMBO_RESULT_LIST_COLUMN_CONFIG_KEY: 'twpub-comboResultListColumnConfig',
  FEEDBACK_CONFIG_KEY: 'twpub-feedbackConfig'
} as const;

export type StorageKey = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS];

export class BrowserStorageUtils {
  // Keys with twpub- prefix and camelCase
  static readonly EXT_TOKEN_KEY = STORAGE_KEYS.EXT_TOKEN_KEY;
  static readonly AUTH_METHOD_KEY = STORAGE_KEYS.AUTH_METHOD_KEY;
  static readonly KEYCLOAK_ADMIN_MODE_KEY = STORAGE_KEYS.KEYCLOAK_ADMIN_MODE_KEY;
  static readonly ACCESS_TOKEN_KEY = STORAGE_KEYS.ACCESS_TOKEN_KEY;
  static readonly COMBO_RESULT_LIST_COLUMN_CONFIG_KEY = STORAGE_KEYS.COMBO_RESULT_LIST_COLUMN_CONFIG_KEY;
  static readonly FEEDBACK_CONFIG_KEY = STORAGE_KEYS.FEEDBACK_CONFIG_KEY;

  static getLocalStorage(key: StorageKey): string | null {
    return localStorage.getItem(key);
  }

  static setLocalStorage(key: StorageKey, value: string): void {
    localStorage.setItem(key, value);
  }

  static removeLocalStorage(key: StorageKey): void {
    localStorage.removeItem(key);
  }

  static getSessionStorage(key: StorageKey): string | null {
    return sessionStorage.getItem(key);
  }

  static setSessionStorage(key: StorageKey, value: string): void {
    sessionStorage.setItem(key, value);
  }

  static removeSessionStorage(key: StorageKey): void {
    sessionStorage.removeItem(key);
  }
}
